import { Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { JournalEntry, JournalFilterInput } from 'app/api/journal.api.service';
import {
    JournalActionTypes,
    JournalLoaded,
    JournalRequested,
    JournalCancelled,
    JournalEntryUpdateRequested,
    JournalEntryUpdateCancelled,
    JournalEntryUpdated
} from './journal.actions';
import { KeyStringFilterInput } from 'app/api/common.api.types';
import { LoadingState, CallState } from 'app/utils/callstate';

// tslint:disable-next-line: no-empty-interface
export interface JournalState extends EntityState<JournalEntry> {
    companyId: string;
    key?: KeyStringFilterInput;
    filter?: JournalFilterInput;
    callState: CallState;
}

export const adapter: EntityAdapter<JournalEntry> = createEntityAdapter<
    JournalEntry
>({
    selectId: entry => entry.key
});
export const initialJournalState: JournalState = adapter.getInitialState({
    companyId: undefined,
    key: undefined,
    filter: undefined,
    callState: LoadingState.Init
});

export function reducer(
    state = initialJournalState,
    action: Action
): JournalState {
    switch (action.type) {
        case JournalActionTypes.JournalRequested:
            const {
                companyId,
                key,
                filter
            } = (action as JournalRequested).payload;
            return {
                ...state,
                companyId,
                key,
                filter,
                callState: LoadingState.Loading
            };
        case JournalActionTypes.JournalLoaded:
            adapter.removeAll(state);
            return adapter.addAll((action as JournalLoaded).payload.journal, {
                ...state,
                callState: LoadingState.Loaded
            });
        case JournalActionTypes.JournalCancelled:
            return {
                ...state,
                callState: {
                    errorMessage: (action as JournalCancelled).payload
                        .errorMessage
                }
            };
        case JournalActionTypes.JournalEntryUpdateRequested:
            return {
                ...state,
                callState: LoadingState.Loading
            };
        case JournalActionTypes.JournalEntryUpdated:
          const entry = (action as JournalEntryUpdated).payload.entry;
          return adapter.updateOne({id: entry.key, changes: entry}, {
                ...state,
                callState: LoadingState.Loaded
            });
        case JournalActionTypes.JournalEntryUpdateCancelled:
            return {
                ...state,
                callState: {
                    errorMessage: (action as JournalEntryUpdateCancelled).payload
                        .errorMessage
                }
            };
        default:
            return state;
    }
}

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
} = adapter.getSelectors();
